import React from 'react';
import { PackingType } from '../../../../app/models/PackingType';
import PackingTypeForm from './PackingTypeForm';
import ButtonCancelForm from '../../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../../components/buttons/ButtonSaveForm';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    packingType: PackingType;
    setPackingType: (packingType: PackingType) => void;
    errorFields?: any;
}

const PackingTypeFormContainer = ({
    fetching,
    action,
    cancel,
    packingType,
    setPackingType,
    errorFields
}: Props) => (
    <>
        <div className="row">
            <div className="col-12">
                <PackingTypeForm
                    packingType={packingType}
                    setPackingType={setPackingType}
                    errorFields={errorFields}
                />
            </div>
        </div>
        <hr />
        <div className="row justify-content-end">
            <div className="col-auto">
                <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
            </div>
            <div className="col-auto">
                <ButtonSaveForm callbackSave={action} locked={fetching} />
            </div>
        </div>
    </>
);

export default PackingTypeFormContainer;
